const SuperAdminEndPoints = {
  /**
   *Account
   */

  userList: {
    url: "/users",
    method: "GET",
  },
  userDetail: (id) => ({
    url: `/user/${id}`,
    method: "GET",
  }),
  vendorList: {
    url: "/vendors",
    method: "GET",
  },
  vendorDetail: (id) => ({
    url: `/vendor/${id}`,
    method: "GET",
  }),
  updateUserStatus: (id) => ({
    url: `/user/status-change/${id}`,
    method: "PUT",
  }),
  updateTripStatus: (id) => ({
    url: `/trip-status/${id}`,
    method: "PUT",
  }),
  updateReviewStatus: (id) => ({
    url: `/review-status/${id}`,
    method: "PUT",
  }),
  // signup: {
  //     url: "/registerVendor",
  //     method: "POST",
  // },
  // verifyOTP: (id) => ({
  //     url: `verify_otp/${id}`,
  //     method: "POST",
  // })
};
export default SuperAdminEndPoints;
export { default as SuperAdminBannerEndPoint } from "./Banner";
export { default as superAdminProfileEndPoint } from "./Profile";
export {default as inquiryEndpoints} from "./Inquiry"
export { default as SuperAdminTaxEndPoint } from "./Tax";
